<div mobile (mobileView)="isMobileView = $event" class="articles-container row">
    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
      <div class="articles-left-content">
        <h4>Articles in this section</h4>
        <ng-template [ngIf]="!isMobileView">
        <ng-template ngFor let-library [ngForOf]="libraryList">
          <div
            class="catalog-list-item catalog-list-item--clickable"
            (click)="selectedLibraryId = library.id"
            [ngClass]="{
              'catalog-list-item--selected': selectedLibraryId == library.id
            }"
          >
            {{ library?.title }}
          </div>
        </ng-template>
      </ng-template>
      <ng-template [ngIf]="isMobileView">
        <div class="form-group stretch">
          <mat-form-field>
              <mat-select
                  disableOptionCentering
                  placeholder="Articles in this section"
                  [(ngModel)]="selectedLibraryId"
                  name="mediaArticle"
                  #mediaArticle="ngModel"
                  (selectionChange)="onSelectionChange($event)"
              >
                  <mat-option
                      *ngFor="let library of libraryList"
                      [value]="library.id"
                  >
                  {{ library?.title }}
                  </mat-option>
              </mat-select>
          </mat-form-field>
      </div>
      </ng-template>
      </div>
    </div>
    <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
      <div *ngIf="libraryMap[selectedLibraryId]" class="articles-right-content">
        <h1>
          {{ libraryMap[selectedLibraryId]["title"] }}
        </h1>
        <div class="article-history align-h margin-top-35 margin-bottom-35">
          <div class="article-history-updated stretch">{{ libraryMap[selectedLibraryId]["translatedModifiedDate"] }}</div>
          <ng-template [ngIf]="!isMobileView">
            <div class="article-history-sharing">
              Share Article to
              <a
                href="https://www.facebook.com/sharer/sharer.php?u={{ pageUrl }}"
                target="_blank"
              >
                <img src="assets/svg/Facebook.svg" alt="facebook" />
              </a>
              <a href="https://twitter.com/share?url={{ pageUrl }}" target="_blank">
                <img src="assets/svg/Twitter.svg" alt="twitter" />
              </a>
              <a
                href="https://www.linkedin.com/shareArticle?url={{ pageUrl }}"
                target="_blank"
              >
                <img src="assets/svg/LinkedIN.svg" alt="linkedin" />
              </a>
            </div>
            <button
            *ngIf="libraryMap[selectedLibraryId]['pdfUrl'] && !inProgress"
              type="button"
              class="btn btn-primary btn-lg pdf-button"
              (click)="downloadAsPDF(libraryMap[selectedLibraryId]['pdfUrl'])"
            >
              <span class="article-history-pdf-download">
                <img src="assets/svg/pdf-file.svg" alt="pdf" />
              </span>
              Download
            </button>
            <mat-spinner *ngIf="inProgress"  [diameter]="25"></mat-spinner>
          </ng-template>
         <ng-template [ngIf]="isMobileView">
          <div class="article-history-sharing--mobile">
            <a
            href="https://www.facebook.com/sharer/sharer.php?u={{ pageUrl }}"
            target="_blank">
            <img src="assets/svg/Facebook.svg" alt="facebook" />
          </a>
          </div>
        <span *ngIf="libraryMap[selectedLibraryId]['pdfUrl'] && !inProgress" class="article-history-pdf-download--mobile" (click)="downloadAsPDF(libraryMap[selectedLibraryId]['pdfUrl'])">
          <img src="assets/svg/pdf-file.svg" alt="pdf" />
        </span>
        <mat-spinner *ngIf="inProgress"  [diameter]="25"></mat-spinner>
         </ng-template>
        </div>
        <div
          class="article-image"
          *ngIf="libraryMap[selectedLibraryId]['imagePath']"
        >
          <img
            [src]="libraryMap[selectedLibraryId]['imagePath']"
            [alt]="libraryMap[selectedLibraryId]['title']"
          />
        </div>
        <div
          class="article-image"
          *ngIf="libraryMap[selectedLibraryId]['video']"
        >
          <iframe class="article-vedio-iframe" [src]="getSafeUrl(libraryMap[selectedLibraryId]['video'])" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
          </iframe>
        </div>
        <p
          class="article-html-content margin-top-35 margin-bottom-35"
          [innerHTML]="libraryMap[selectedLibraryId]['htmlContent']"
        ></p>
      </div>
    </div>
  </div>
  